module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="tabs">\n    <span class="tab users active">Users</span>\n</div>\n<div class="tab-pane users active">\n    <section class="current-user">\n        <h4>Your Profile</h4>\n        <div class="user-profile">\n            <span class="user-color" style="background:' +
__e( backgroundColor ) +
'"><span class="you">You</span></span>\n            <ul class="info-user current-user-profile">\n                <li class="details editable-container">\n                    <div class="current-user-name editable" contenteditable="true"></div>\n                </li>\n                <li class="current-user-email">Email here</li>\n                ';
 if (adLogin) { ;
__p += '\n                    <li class="current-accessed-at"></li>\n                ';
 } ;
__p += '\n                <li class="current-user-company">' +
__e( companyName) +
'</li>\n                ';
 if (adLogin && salesForceId) { ;
__p += '\n                    <li>' +
__e( salesForceId) +
'</li>\n                ';
 } ;
__p += '\n            </ul>\n\n            <div class="info-permission">\n                <input type="text" class="current-user-permissions-display" disabled readonly />\n            </div>\n\n            <div class="clearfix"></div>\n        </div>\n    </section>\n\n    <section class="other-users">\n        ';
 if (hasMultipleUsers) { ;
__p += '\n            <section class="header">\n                <h4>' +
__e( companyName) +
' Users</h4>\n                <button class="btn btn-secondary btn-add-user';
 if (cannotAdd) { ;
__p += ' disabled';
 } ;
__p += '"';
 if (cannotAdd) { ;
__p += ' disabled';
 } ;
__p += '>&#43; Add User</button>\n            </section>\n        ';
 } else { ;
__p += '\n            <button class="btn btn-secondary btn-add-user';
 if (cannotAdd) { ;
__p += ' disabled';
 } ;
__p += '"';
 if (cannotAdd) { ;
__p += ' disabled';
 } ;
__p += '>&#43; Add User</button>\n        ';
 } ;
__p += '\n        <section id="users"></section>\n    </section>\n\n    ';
 if (unconfirmed) { ;
__p += '\n    <section class="unconfirmed">\n        <span>An unconfirmed user, e.g. <strong>' +
__e(unconfirmed) +
'</strong>, will always be a Spectator until the user\'s identity has been confirmed.<br><br></span>\n    </section>\n    ';
 } ;
__p += '\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/settings/manageAccount/ManageAccountCompositeView.tpl
// module id = 3114
// module chunks = 0